import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {Storage} from "@ionic/storage";
import {EdituserPage} from "../../pages/edituser/edituser";
import {RicercautentiPage} from "../../pages/ricercautenti/ricercautenti";
import {AuthProvider} from "../../providers/auth/auth";
import {AddutentePage} from "../../pages/addutente/addutente";
import { Events } from 'ionic-angular';

/**
 * Generated class for the UtentiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-utenti',
  templateUrl: 'utenti.html',
})
export class UtentiPage {
  users;
  user;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private readonly storage: Storage,
    private readonly authProvider: AuthProvider,
    public events: Events,
    public rest: RestApiProvider
  ) {

  }
  logout(){
    this.authProvider.logout();

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad UtentiPage');
    this.getUser();
  }
  getUsers() {
    this.rest.getUsersList().subscribe(
      users => this.users = users,
      error => this.errorMessage = <any>error);
  }
  getUser() {
    this.rest.getUser().subscribe(
      user => {this.user = user;
        if(user!=null){
          this.events.publish('nameStore:updated', user.username);

        }

      },
      error => this.errorMessage = <any>error);
  }
  ionViewWillEnter () {
    this.getUsers();
    this.getUser();

  }
  selStore(user){
    this.user=user;
    this.events.publish('nameStore:updated', user.username);

    //alert(JSON.stringify(user));
    this.rest.getSelStore(user.id);
    this.storage.set("user", user);
   // alert("Selezionato user: "+user.username);
  }
  edit(user){
    this.navCtrl.push(EdituserPage, { userAdmin: user});

  }
  addUtente(){
    this.navCtrl.push(AddutentePage);

  }
  search(){
    this.navCtrl.push(RicercautentiPage);

  }
}



// WEBPACK FOOTER //
// ./src/pages/utenti/utenti.ts